export * from "./default-img";
export * from "./circular-img";
export * from "./img-with-shadow";
export * from "./img-with-caption";
export * from "./img-with-rounded-corners";
export * from "./img-with-blurred-caption";